//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngCommitmentToDataPrivacy', srsngCommitmentToDataPrivacy);

    function srsngCommitmentToDataPrivacy($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/commitment-to-data-privacy/commitment-to-data-privacy.html',
            scope: {
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

